import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useReactiveVar } from '@apollo/client';

import { CheckboxGroup } from '../../../../common/form/checkbox-group';
import { ICheckboxGroupItem } from '../../../../common/checkbox-group';
import { IProfileNotificationsProps } from './profile-notifications.models';
import { NotificationsType } from '../../../../../graphql/profile/models/get-profile.models';
import { setIsPhoneCallConsent, setMms } from '../../../../../graphql/configuration/configuration.cache';
import { useStyles } from './profile-notifications.styles';

const basePermissions: ICheckboxGroupItem[] = [{
  label: <FormattedMessage id="profile.checkboxesItem.email" />,
  value: NotificationsType.email,
}, {
  label: <FormattedMessage id="profile.checkboxesItem.sms" />,
  value: NotificationsType.sms,
}, {
  label: <FormattedMessage id="profile.checkboxesItem.push" />,
  value: NotificationsType.push,
}];

export const ProfileNotifications = ({
  name,
}: IProfileNotificationsProps): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();

  const isPhoneCallConsent = useReactiveVar(setIsPhoneCallConsent);
  const isMms = useReactiveVar(setMms);

  const mmsPermission: ICheckboxGroupItem = {
    label: <FormattedMessage id="profile.checkboxesItem.mms" />,
    value: NotificationsType.mms,
    labelStyles: classes.mms,
  };

  const phoneCallPermission: ICheckboxGroupItem = {
    label: intl.formatMessage(
      { id: 'profile.checkboxesItem.phone' },
      { sup: (chunks: React.ReactNode) => <sup>{chunks}</sup> },
    ),
    value: NotificationsType.phoneCall,
    labelStyles: classes.label,
  };

  const permissions = [
    ...basePermissions,
    ...(isMms ? [mmsPermission] : []),
    ...(isPhoneCallConsent ? [phoneCallPermission] : []),
  ];

  return (
    <CheckboxGroup
      title={<FormattedMessage id="profile.checkboxes.title" />}
      options={permissions}
      name={name}
    />
  );
};
